import React from 'react';
import { ShieldCheckIcon, AlertTriangleIcon, AlertOctagonIcon } from 'lucide-react';
export function SemaforoSection() {
  return <section className="w-full bg-gray-50" aria-label="Semáforo de Triage" data-id="element-213">
      <div className="max-w-3xl mx-auto px-5 py-16 md:py-24" data-id="element-214">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] text-center leading-tight mb-3" data-id="element-215">
          Semáforo Dental
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12" data-id="element-216">
          Verde / Amarillo / Rojo en 2 minutos.
        </p>

        <div className="space-y-6" data-id="element-217">
          {/* Verde */}
          <div className="bg-white border-2 border-[#10B981] rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-218">
            <div className="flex items-center gap-3 mb-4" data-id="element-219">
              <div className="w-12 h-12 rounded-full bg-[#10B981] flex items-center justify-center flex-shrink-0" data-id="element-220">
                <ShieldCheckIcon className="w-6 h-6 text-white" aria-hidden="true" data-id="element-221" />
              </div>
              <div data-id="element-222">
                <h3 className="text-xl font-bold text-[#10B981]" data-id="element-223">
                  VERDE — Puedes manejar en casa
                </h3>
              </div>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-224">
              Dolor leve a moderado, sin hinchazón visible, sin fiebre. Puedes
              seguir el protocolo de alivio temporal y agendar cita esta semana.
            </p>
          </div>

          {/* Amarillo */}
          <div className="bg-white border-2 border-[#F59E0B] rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-225">
            <div className="flex items-center gap-3 mb-4" data-id="element-226">
              <div className="w-12 h-12 rounded-full bg-[#F59E0B] flex items-center justify-center flex-shrink-0" data-id="element-227">
                <AlertTriangleIcon className="w-6 h-6 text-white" aria-hidden="true" data-id="element-228" />
              </div>
              <div data-id="element-229">
                <h3 className="text-xl font-bold text-[#F59E0B]" data-id="element-230">
                  AMARILLO — Necesitas atención pronto
                </h3>
              </div>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-231">
              Dolor intenso que no cede con analgésicos, hinchazón leve,
              sensibilidad extrema. Busca cita de emergencia mañana. Usa los
              guiones de llamada incluidos.
            </p>
          </div>

          {/* Rojo */}
          <div className="bg-white border-2 border-[#EF4444] rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-232">
            <div className="flex items-center gap-3 mb-4" data-id="element-233">
              <div className="w-12 h-12 rounded-full bg-[#EF4444] flex items-center justify-center flex-shrink-0" data-id="element-234">
                <AlertOctagonIcon className="w-6 h-6 text-white" aria-hidden="true" data-id="element-235" />
              </div>
              <div data-id="element-236">
                <h3 className="text-xl font-bold text-[#EF4444]" data-id="element-237">
                  ROJO — Ve a urgencias ahora
                </h3>
              </div>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-238">
              Fiebre alta, hinchazón que sube hacia el ojo o cuello, dificultad
              para tragar o respirar, pus visible. No esperes. La guía te dice
              exactamente a dónde ir.
            </p>
          </div>
        </div>

        <p className="text-center text-gray-500 text-base mt-8 italic" data-id="element-239">
          "Si es emergencia, lo vas a saber." — Eso es lo que te da el semáforo.
        </p>
      </div>
    </section>;
}